module.exports = __webpack_public_path__ + "img/ios_qrcode.aa936f5d.png";